export default __webpack_public_path__ + "static/media/Success.8a224f4a.svg";